import { render, staticRenderFns } from "./cancelHandle.vue?vue&type=template&id=95f0d752&scoped=true&"
import script from "./cancelHandle.vue?vue&type=script&lang=js&"
export * from "./cancelHandle.vue?vue&type=script&lang=js&"
import style0 from "./cancelHandle.vue?vue&type=style&index=0&id=95f0d752&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f0d752",
  null
  
)

export default component.exports